import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetAllStudentsForCSVResponse {
  firstName: string;
  lastName: string;
  dob: string;
  familyName: string;
  gender: string;
  tShirtSize: string;
  transportation: string;
  medical: {
    primaryDoctor?: string;
    medications?: string;
    allergies?: string;
    disabilities?: string;
    specialNeeds?: string;
    healthInsuranceCarrier?: string;
  };
  enrollments?: Array<string>;
  parent: string;
  studio: string;
}

export const getAllStudentsForCSVAPI = async () => {
  const response = await baseAPI.get<Array<GetAllStudentsForCSVResponse>>(
    `/students/studio/all/csv`,
  );
  return response.data;
};

export const getAllStudentsForCSVQueryOptions = (enabled: boolean) =>
  queryOptions({
    queryKey: [KEYS.STUDENTS_CSV],
    queryFn: getAllStudentsForCSVAPI,
    enabled: enabled,
  });

export const useGetAllStudentsForCSV = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    ...getAllStudentsForCSVQueryOptions(enabled),
  });
};
